import { ProductImageUploadTranslations } from "./product-image-upload-pt-br";

export const PRODUCT_IMAGE_UPLOAD_FR_FR: ProductImageUploadTranslations = {
	addImage: "Ajouter une image",
	removeImage: "Supprimer l'image téléchargée",
	formatInfo: "JPG ou PNG",
	ariaLabel: {
		uploadedImage: "Image du produit téléchargée",
	},
};
